import React from 'react';
import { ToneChip } from '../../common/StatusChip';
import { JournalEntry } from '../../../types/finance';

/** Posted, reversed, or a reversal — the only states a voucher has. */
const JournalStatusChip: React.FC<{ entry: Pick<JournalEntry, 'status' | 'reversesEntryId'> }> = ({ entry }) => {
  if (entry.reversesEntryId) return <ToneChip tone="info" label="Reversal" size="small" />;
  if (entry.status === 'REVERSED') return <ToneChip tone="warning" label="Reversed" size="small" />;
  return <ToneChip tone="success" label="Posted" size="small" />;
};

export default JournalStatusChip;
